import React, {
  Suspense,
  useEffect,
  useState,
  useCallback,
} from "react";

import "./dashboard.css";

import {
  Container,
  Table,
  Form,
  Button,
  Modal,
} from "react-bootstrap";
import { toast } from "react-toastify";

import {
  ArrowLeft,
  Search,
  Plus,
  MoreVertical,
  ChevronRight,
} from "lucide-react";

import {
  Link,
  useNavigate,
} from "react-router-dom";

import axios from "axios";

import ResultsPagination from "../components/ResultsPagination";

const PopUpModal = React.lazy(() =>
  import("../components/modal/PopUpModal")
);

const API_BASE_URL = `${process.env.REACT_APP_BASE_API_URL}`;

const MailerList = () => {
  const navigate = useNavigate();

  const [searchValue, setSearchValue] = useState("");

  const [showAddModal, setShowAddModal] = useState(false);

  const [activeMenu, setActiveMenu] = useState(null);

  const [selectedItem, setSelectedItem] = useState(null);

  const [data, setData] = useState([]);

  const [loading, setLoading] = useState(false);

  const [showFilesModal, setShowFilesModal] = useState(false);

  const [selectedFiles, setSelectedFiles] = useState([]);

  const [modalPosition, setModalPosition] = useState({
    top: 0,
    left: 0,
  });

  const [page, setPage] = useState(1);

  const [limit, setLimit] = useState(10);

  const [total, setTotal] = useState(0);

  const [totalPages, setTotalPages] = useState(1);
const [categoryOptions, setCategoryOptions] = useState([]); 
  const [selectedMailers, setSelectedMailers] = useState([]);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
const formatKeyword = (keyword) => {
  if (!keyword) return "-";
  if (typeof keyword !== "string") return keyword;

  return keyword
    .toLowerCase()
    .split(" ")
    .map(w => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
};
  const fetchMailers = useCallback(async () => {
    try {
      setLoading(true);

  const response = await axios.get(
  `${API_BASE_URL}/api/mailers`,
  {
    params: { page, limit, search: searchValue },
    withCredentials: true
  }
);

setData(response.data?.data || []);
setTotal(response.data?.total || 0);
setTotalPages(response.data?.totalPages || 1);
setSelectedMailers([]);
setCategoryOptions(response.data?.categories || []);   // 👈 ADD THIS LINE

      setData(response.data?.data || []);
      setTotal(response.data?.total || 0);
      setTotalPages(response.data?.totalPages || 1);
      setSelectedMailers([]);

    } catch (error) {
      console.error("Error fetching mailers:", error);
    } finally {
      setLoading(false);
    }
  }, [page, limit, searchValue]);

  useEffect(() => {
    fetchMailers();
  }, [fetchMailers]);

  useEffect(() => {
    const closeMenu = () => {
      setActiveMenu(null);
    };

    window.addEventListener("click", closeMenu);

    return () => {
      window.removeEventListener("click", closeMenu);
    };
  }, []);

  const handlePerPageChange = (value) => {
    setLimit(Number(value));
    setPage(1);
  };

  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
    setPage(1);
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedMailers(data.map((item) => item._id));
    } else {
      setSelectedMailers([]);
    }
  };

  const handleSelectOne = (e, id) => {
    if (e.target.checked) {
      setSelectedMailers((prev) => [...prev, id]);
    } else {
      setSelectedMailers((prev) => prev.filter((selectedId) => selectedId !== id));
    }
  };

  const handleBulkDelete = () => {
    if (selectedMailers.length === 0) {
      toast.warn("Please select at least one mailer to delete.");
      return;
    }
    setDeleteTarget("bulk");
    setShowDeleteModal(true);
  };

  const handleDelete = (id) => {
    setDeleteTarget(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    try {
      if (deleteTarget === "bulk") {
        await axios.delete(`${API_BASE_URL}/api/mailers`, {
          data: { ids: selectedMailers },
          withCredentials: true
        });
        setSelectedMailers([]);
        toast.success(`${selectedMailers.length} user(s) deleted successfully`);
      } else {
        await axios.delete(
          `${API_BASE_URL}/api/mailers/${deleteTarget}`,
          { withCredentials: true }
        );
        toast.success("User deleted successfully");
      }
      fetchMailers();
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("There was an error deleting the user(s).");
    } finally {
      setShowDeleteModal(false);
      setDeleteTarget(null);
    }
  };

  const handleShowFiles = async (item, event) => {
    try {
      const rect = event.currentTarget.getBoundingClientRect();

      setModalPosition({
        top: rect.top + window.scrollY,
        left: rect.left + window.scrollX,
      });

      setShowFilesModal(true);
      setSelectedFiles([]);

      const token = localStorage.getItem('token');

      const response = await axios.get(
        `${API_BASE_URL}/api/user-documents/${item._id}`,
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      const files = response.data?.data || response.data || [];

      // Format files with proper fields
      const formattedFiles = files.map(file => ({
        ...file,
        id: file.id || file.document_id || file._id,
        document_id: file.document_id || file.id || file._id,
        name: file.file_name || file.name || 'document',
        file_url: file.file_url || file.file_path || null
      }));

      setSelectedFiles(formattedFiles);

    } catch (error) {
      console.error("Fetch documents error:", error);
      toast.error("Failed to load documents. Please try again.");
    }
  };

  const handleCloseFiles = () => {
    setShowFilesModal(false);
    setSelectedFiles([]);
  };

const downloadSingleFile = (file) => {
  const fileId = file.document_id || file.id || file._id;
  if (!fileId) {
    toast.error('File ID not found');
    return;
  }

  window.open(`${API_BASE_URL}/api/file/download/${fileId}`, "_blank");
  toast.info('Download started...');
};
const downloadAllFiles = async () => {
  const validFiles = selectedFiles.filter(file => 
    file.document_id || file.id || file._id
  );

  if (validFiles.length === 0) {
    toast.warning("No valid files to download");
    return;
  }

  try {
    toast.info(`Preparing to download ${validFiles.length} file(s)...`);
    
    // Download files one by one using fetch
    for (let i = 0; i < validFiles.length; i++) {
      const file = validFiles[i];
      const fileId = file.document_id || file.id || file._id;
      
      if (!fileId) continue;

      try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_BASE_URL}/api/file/download/${fileId}`, {
          headers: {
            'Authorization': token ? `Bearer ${token}` : ''
          }
        });

        if (!response.ok) {
          console.error(`Failed to download ${file.name}:`, response.status);
          continue;
        }

        // Get the blob from response
        const blob = await response.blob();
        
        // Create download link
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = file.name || `document_${i+1}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        // Clean up the URL object
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
        }, 100);

        // Small delay between downloads to prevent browser issues
        if (i < validFiles.length - 1) {
          await new Promise(resolve => setTimeout(resolve, 500));
        }
      } catch (err) {
        console.error(`Error downloading ${file.name}:`, err);
        // Continue with next file even if one fails
      }
    }

    toast.success(`Successfully downloaded ${validFiles.length} file(s)`);
  } catch (error) {
    console.error("Download all error:", error);
    toast.error("Failed to download all files. Please try downloading individually.");
  }
};
  return (
    <>
      <nav
        aria-label="breadcrumb"
        style={{
          "--bs-breadcrumb-divider": "''",
        }}
      >
        <ol
          className="breadcrumb d-flex align-items-center py-2 mb-0"
          style={{ fontSize: "14px" }}
        >
          <li className="breadcrumb-item d-flex align-items-center">
            <Link
              to="/"
              className="text-decoration-none text-secondary"
            >
              Home
            </Link>

            <ChevronRight
              size={16}
              className="mx-1 text-secondary"
            />
          </li>

          <li
            className="breadcrumb-item fw-semibold"
            style={{
              color: "#2F7F8F",
            }}
          >
            Mailer List
          </li>
        </ol>
      </nav>

      <Container fluid className="py-3 px-4">
        <style>
          {`
            .form-check-input:checked {
              background-color: #2F7F8F !important;
              border-color: #2F7F8F !important;
            }
          `}
        </style>

        <h5 className="mb-3 fw-bold">
          Mailer List
        </h5>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "24px",
            gap: "12px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              flex: 1,
              maxWidth: "420px",
              border: "1px solid rgba(209, 213, 219, 1)",
              borderRadius: "38px",
              padding: "4px 8px 4px 12px",
              background: "#fff",
            }}
          >
            <Search
              size={16}
              color="#6c757d"
              style={{ flexShrink: 0 }}
            />

            <Form.Control
              placeholder="Search Customers"
              aria-label="Search customers"
              value={searchValue}
              onChange={handleSearchChange}
              style={{
                border: "none",
                boxShadow: "none",
                padding: "4px 0",
                fontSize: "14px",
                background: "transparent",
              }}
            />

            <button
              type="button"
              style={{
                border: "none",
                borderRadius: "50%",
                width: "36px",
                height: "36px",
                backgroundColor: "#2F7F8F",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                cursor: "pointer",
              }}
            >
              <Search
                size={16}
                color="#fff"
              />
            </button>
          </div>

          <div className="d-flex align-items-center gap-3">
            <Button
              variant="link"
              className="p-0"
              style={{
                textDecoration: "none",
                fontWeight: 500,
                color: "#2F7F8F",
              }}
              onClick={handleBulkDelete}
            >
              Delete
            </Button>

            <Button
              style={{
                backgroundColor: "#2F7F8F",
                border: "none",
                borderRadius: "999px",
                padding: "7px 18px",
                fontWeight: 500,
              }}
              onClick={() =>
                setShowAddModal(true)
              }
            >
              <Plus
                size={16}
                className="me-1"
              />
              Add
            </Button>
          </div>
        </div>

        <div
          style={{
            border: "1px solid rgba(229, 231, 235, 1)",
            borderRadius: "12px",
            overflowX: "auto",
            overflowY: "hidden",
            background: "#fff",
          }}
        >
        <Table hover className="mb-0 align-middle text-center">
 
            <thead>
              <tr
                style={{
                  backgroundColor: "#E5E7EB",
                }}
              >
                <th
                  style={{
                    width: "40px",
                    backgroundColor: "#E5E7EB",
                    border: "none",
                    padding: "14px 12px",
                  }}
                >
                  <Form.Check
                    type="checkbox"
                    checked={data.length > 0 && selectedMailers.length === data.length}
                    onChange={handleSelectAll}
                  />
                </th>

                <th className="table-head">
                  Name
                </th>

                <th className="table-head">
                 Category
                </th>

                <th className="table-head">
                  Plan
                </th>

                <th className="table-head">
                  Email
                </th>

                <th className="table-head">
                  Keywords
                </th>

                <th className="table-head">
                  States
                </th>

                <th className="table-head">
                  Documents
                </th>

                <th
                  className="table-head"
                  style={{ width: "100px" }}
                >
                  Actions
                </th>
              </tr>
            </thead>

            <tbody>
              {data.map((item, index) => (
                <tr
                  key={item._id}
                  style={{
                    borderBottom: "1px solid rgba(229, 231, 235, 1)",
                  }}
                >
                  <td
                    style={{
                      padding: "16px 12px",
                      border: "none",
                    }}
                  >
                    <Form.Check
                      type="checkbox"
                      checked={selectedMailers.includes(item._id)}
                      onChange={(e) => handleSelectOne(e, item._id)}
                    />
                  </td>

                  <td className="table-cell fw-semibold">
                    {item.name}
                  </td>

                  <td className="table-cell">
                    {item.company}
                  </td>

                  <td className="table-cell">
                    {item.plan_name || '-'}
                  </td>

                  <td className="table-cell">
                    {item.email}
                  </td>

            <td className="table-cell">
  {item.pending_keywords ? (
    <span className="text-dark rounded-pill px-3 py-1">New Request</span>
  ) : item.keywords?.length > 0 ? (
    <>
      {[...item.keywords]
        .sort((a, b) => a.localeCompare(b))
        .slice(0, 2)
        .map(formatKeyword)     // 👈 added
        .join(", ")}

      {item.keywords.length > 2 &&
        ` +${item.keywords.length - 2}`}
    </>
  ) : (
    "-"
  )}
</td>

                  <td className="table-cell">
                    {item.pending_states ? (
                      <span className="badge bg-warning text-dark rounded-pill px-3 py-1">New Request</span>
                    ) : item.states?.length > 0
                      ? (
                        <>
                          {[...item.states]
                            .sort((a, b) =>
                              a.localeCompare(b)
                            )
                            .slice(0, 2)
                            .join(", ")}

                          {item.states.length > 2 &&
                            ` +${item.states.length - 2}`}
                        </>
                      )
                      : "-"}
                  </td>

                  <td className="table-cell">
                    <a
                      href="/#"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();

                        handleShowFiles(
                          item,
                          e
                        );
                      }}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "5px",
                        color: "#3b82f6",
                        textDecoration: "none",
                        fontSize: "14px",
                        cursor: "pointer",
                      }}
                    >
                      <img
                        src="/images/link.svg"
                        alt="link"
                        style={{ width: "16px" }}
                      />

                      {item.documents_count} files
                    </a>
                  </td>

                  <td className="table-cell">
                    <div
                      style={{
                        position: "relative",
                      }}
                    >
                      <div
                        onClick={(e) => {
                          e.stopPropagation();

                          setActiveMenu(
                            activeMenu === item._id
                              ? null
                              : item._id
                          );
                        }}
                        style={{
                          cursor: "pointer",
                        }}
                      >
                        <MoreVertical size={16} />
                      </div>

                      {activeMenu === item._id && (
                        <div
                          style={{
                            position: "absolute",
                            top: index >= data.length - 2 && data.length > 3
                              ? "auto"
                              : "30px",
                            bottom: index >= data.length - 2 && data.length > 3
                              ? "30px"
                              : "auto",
                            right: "10px",
                            background: "#fff",
                            border: "1px solid #ddd",
                            borderRadius: "6px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                            zIndex: 9999,
                            minWidth: "120px",
                          }}
                        >
                          <div
                            style={{
                              padding: "8px 12px",
                              cursor: "pointer",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();

                              setSelectedItem(item);
                              setShowAddModal(true);
                              setActiveMenu(null);
                            }}
                          >
                            Edit
                          </div>

                          <div
                            style={{
                              padding: "8px 12px",
                              cursor: "pointer",
                              color: "#2F7A87",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();

                              handleDelete(item._id);
                              setActiveMenu(null);
                            }}
                          >
                            Delete
                          </div>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          {!loading && (
            <div className="table-footer gap-3 p-3 d-flex align-items-center justify-content-between border-top">
              <span className="text-muted small">
                Showing{" "}
                {total === 0
                  ? 0
                  : (page - 1) * limit + 1}
                –
                {Math.min(
                  page * limit,
                  total
                )}{" "}
                of {total}
              </span>

              <div className="me-2">
                <ResultsPagination
                  activePage={page}
                  setActivePage={setPage}
                  perPage={limit}
                  setPerPage={handlePerPageChange}
                  totalPages={totalPages}
                  perPageOptions={[
                    10,
                    15,
                    20,
                    25,
                    30,
                  ]}
                />
              </div>
            </div>
          )}

        {showAddModal && (
  <Suspense fallback={null}>
    <PopUpModal
      show={showAddModal}
      onHide={() => {
        setShowAddModal(false);
        setSelectedItem(null);
      }}
      data={selectedItem}
      refreshList={fetchMailers}
      categoryOptions={categoryOptions}
    />
  </Suspense>
)}
        </div>

        {/* Files Modal */}
        {showFilesModal && (
          <div
            className="custom-files-modal border rounded"
            style={{
              position: "absolute",
              top: modalPosition.top,
              left: modalPosition.left,
              transform: "translate(-50%, -100%)",
              zIndex: 9999,
            }}
          >
            <div className="modal-content shadow">
              <div className="modal-header py-2">
                <h6 className="mb-0">
                  {selectedFiles.length} Files
                </h6>

                <button
                  className="btn-close"
                  onClick={handleCloseFiles}
                />
              </div>

              <div className="modal-body p-2">
                {selectedFiles.length >   0 ? (
                  selectedFiles.map(
                    (file, idx) => (
                      <div
                        key={idx}
                        className={`d-flex justify-content-between align-items-center py-2 ${idx !==
                          selectedFiles.length -
                          1
                          ? "border-bottom"
                          : ""
                         
                                           }`}
                    >
                      <span>
                        {file.name}
                      </span>

                      <div className="d-flex gap-3">
                        {/* View Icon */}
                        <i
                          className="bi bi-eye icon-eyes"
                          style={{
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            const fileId = file.document_id || file.id;
                            if (fileId) {
                              window.open(
                                `${API_BASE_URL}/api/file/view/${fileId}`,
                                "_blank",
                                "noopener,noreferrer"
                              );
                            }
                          }}
                        />

                        {/* Download Icon - FIXED */}
                        <i
                          className="bi bi-download icon-eyes"
                          style={{
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            downloadSingleFile(file);
                          }}
                        />
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-muted text-center py-2">
                    Loading files...
                  </div>
                )}
              </div>

              <div className="modal-footer py-2 d-flex justify-content-end border-top">
                <button
                  className="btn btn-sm icon-eyes fw-semibold d-flex align-items-center gap-2"
                  onClick={downloadAllFiles}
                >
                  <i className="bi bi-download fw-semibold"></i>
                  Download All
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Delete Confirmation Modal */}
        <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered backdrop="static">
          <Modal.Header closeButton style={{ borderBottom: '1px solid #e5e7eb', padding: '16px 24px' }}>
            <Modal.Title style={{ fontSize: '18px', fontWeight: 600, color: '#111827' }}>
              Confirm Deletion
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: '24px', fontSize: '15px', color: '#374151' }}>
            {deleteTarget === "bulk"
              ? `Are you sure you want to delete ${selectedMailers.length} mailer(s)? This action cannot be undone.`
              : "Are you sure you want to delete this mailer? This action cannot be undone."}
          </Modal.Body>
          <Modal.Footer style={{ borderTop: 'none', padding: '16px 24px 24px', gap: '12px' }}>
            <button
              className="mailer-modal-cancel-btn"
              onClick={() => setShowDeleteModal(false)}
            >
              Cancel
            </button>
            <button
              className="mailer-modal-delete-btn"
              onClick={confirmDelete}
            >
              Delete
            </button>
          </Modal.Footer>
        </Modal>
      </Container>
    </>
  );
};

export default MailerList;